import api from './api';

export interface EmailTemplate {
  id: string;
  name: string;
  type: 'master' | 'content';
  subject: string | null;
  html_content: string;
  variables_schema: Record<string, unknown> | null;
  is_default: boolean;
  created_at: string;
  updated_at: string | null;
}

const emailTemplateService = {
  /**
   * List all email templates
   */
  list: async () => {
    const response = await api.get('/email-templates');
    return response.data as EmailTemplate[];
  },

  /**
   * Get template by ID
   */
  getById: async (id: string) => {
    const response = await api.get(`/email-templates/${id}`);
    return response.data as EmailTemplate;
  },

  /**
   * List content templates only (for selection dropdowns)
   */
  listContentTemplates: async () => {
    const templates = await emailTemplateService.list();
    return templates.filter((t) => t.type === 'content');
  },
};

export default emailTemplateService;
